import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';

import { DefaultModal } from '@libs/ui/components/modals';

interface SuccessApplyModalProps {
  open: boolean;
  handleClose: VoidFunction;
}

const SuccessApplyModal = ({
  open,
  handleClose,
}: SuccessApplyModalProps) => {
  const { t } = useTranslation('talentMatcher');
  return (
    <DefaultModal
    open={open}
    handleClose={handleClose}
    title={t('applySuccess.title')}
  >
    <Grid spacing={4} direction="column" container>
      <Grid item>We’ll contact with you soon</Grid>
    </Grid>
  </DefaultModal>
  );
};

export default SuccessApplyModal;
